import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UserDetailVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveUser = createAsyncThunk<UserDetailVM, string, { extra: Partial<Dependencies> }>(
  "users/retrieveUser",
  async (id: string, { extra: { adminRepository } }) => {
    return adminRepository!.getUser(id);
  },
);

export const resetRetrieveUser = createAction("users/resetRetrieveUser");
